import { makeStyles } from 'tss-react/mui';

import { CONTAINER_STYLES } from 'modules/layout/components/DefautLayout';

const name = 'ChainsListPageLayout';

export const useChainsListPageLayoutStyles = makeStyles({ name })(() => ({
  root: {
    ...CONTAINER_STYLES,
  },
}));
